"use strict";

require("../../style/default.less");
require("./index.less");
require("../../empty/style");
require("../../grid/style");
require("../../pagination/style");
require("../../spin/style");